import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { FileUpload } from '../../Redux/UploadSlice';
const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box',
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%',
};

RHFileUpload.propTypes = {
    name: PropTypes.string,
    setImage: PropTypes.func,
    list: PropTypes.array,
};



function RHFileUpload({ name, image, setImage }) {

    const dispatch = useDispatch()

    const [files, setFiles] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': [],
        },
        onDrop: (acceptedFiles) => {

            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                    ,
                ),
            );
            acceptedFiles.map((file) => {
                console.log('acceptedFiles', acceptedFiles)

                const formData = new FormData()
                formData.append('image', file)
                dispatch(FileUpload(formData)).then((response) => {
                    setImage({ ...image, [`${name}`]: response.payload.data?.response })
                })
            }

            )

        },
    });

    const removeFile = (index) => {
        const updatedFiles = [...files];
        updatedFiles.splice(index, 1);
        setFiles(updatedFiles);
    };


    return (
        <section className='container'>
            <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <p>{`Drag 'n' drop some files here, or click to select files`}</p>
            </div>
            <aside style={thumbsContainer}>
                <div style={thumb} >
                    <div style={thumbInner}>
                        <img
                            src={image?.[name]?.url}
                            style={img}
                            alt='img'
                        />
                        <button onClick={() => removeFile(name)}>Remove</button>
                    </div>
                </div></aside>
        </section>
    );
}

export default RHFileUpload;
